import logo from './footer-csts.png';

export default function Footer() {
  return <img style={{ width: '100px', height: '57px' }} alt="Footer" src={logo} />;
}
